import React from 'react';

import { useCurrentProject } from '@adsk/alloy-provider';
import StatusColorIndicator from '@adsk/alloy-react-status-color-indicator';
import Theme from '@adsk/alloy-react-theme';

import EntityMenuItem from '../../../EntityMenuItem';
import {
  getStatus,
  STATUS_COLOR_MAPPING,
  shouldShowStatus,
  MAPPING_KEY,
  MAPPING_ICON,
} from '../helpers/consts';
import { getDeepLink } from '../helpers/formatEntities';

const EntityCellItem = ({ entity, type = '', ...rest }) => {
  const project = useCurrentProject();
  const link = getDeepLink(entity, project, type);

  const { name } = entity;
  const statusColor = STATUS_COLOR_MAPPING[getStatus(type, entity)];
  const label = (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {shouldShowStatus(type) && (
        <StatusColorIndicator
          statusColor={statusColor}
          style={{
            width: '3px',
            height: '16px',
            cursor: 'default',
            flexShrink: 0,
          }}
        />
      )}
      {entity[MAPPING_KEY[type]] && entity[MAPPING_KEY[type]] !== '-' && (
        <span style={{ paddingLeft: 6, color: Theme.colors.adskBlue700 }}>
          {entity[MAPPING_KEY[type]]}
        </span>
      )}
      <span style={{ paddingLeft: 6, color: Theme.colors.charcoal900 }}>
        {name}
      </span>
    </div>
  );
  return (
    <EntityMenuItem
      link={link}
      label={label}
      renderIcon={MAPPING_ICON[type]}
      {...rest}
    />
  );
};

export default EntityCellItem;
